export const MIN_MULTISIG_MEMBERS = 2
export const MIN_MULTISIG_THRESHOLD = 1

export const DUMMY_MULTISIG_ID = 'DUMMY_MULTISIG'

export enum MultisigCallNames {
  ApproveAsMulti = 'Multisig.approve_as_multi',
  AsMulti = 'Multisig.as_multi',
  AsMultiThreshold1 = 'Multisig.as_multi_threshold_1',
}
